'use client';

import { Label, Switch } from '@up2stay/up2promo-ui';

import { AutosaveStatusCue } from '@/core/components/ui/autosave-status-cue';
import { SettingsGroupRow } from '@/core/components/settings/settings-group';
import { SettingsInfoHint } from '@/core/components/settings/settings-info-hint';
import { SettingsSection } from '@/core/components/settings/settings-section';
import type { AutosaveCueStatus } from '@/core/hooks/use-autosave-cue';

interface LeadsVisibilitySectionProps {
  sectionId: string;
  dict: {
    title: string;
    description: string;
    switchLabel: string;
  };
  checked: boolean;
  disabled?: boolean;
  pending?: boolean;
  autosaveStatus?: AutosaveCueStatus;
  onCheckedChange: (checked: boolean) => void;
}

export function LeadsVisibilitySection({
  sectionId,
  dict,
  checked,
  disabled,
  pending,
  autosaveStatus = 'idle',
  onCheckedChange,
}: LeadsVisibilitySectionProps) {
  return (
    <SettingsSection
      id={sectionId}
      title={dict.title}
      grouped
      actions={<AutosaveStatusCue status={autosaveStatus} />}
    >
      <SettingsGroupRow>
        <div className="flex items-center justify-between gap-3">
          <div className="flex min-w-0 flex-1 items-center gap-0.5">
            <Label
              htmlFor="workspace-leads-always-visible"
              className="cursor-pointer font-medium"
            >
              {dict.switchLabel}
            </Label>
            <SettingsInfoHint label={dict.switchLabel}>
              {dict.description}
            </SettingsInfoHint>
          </div>
          <Switch
            id="workspace-leads-always-visible"
            checked={checked}
            disabled={disabled || pending}
            onCheckedChange={onCheckedChange}
          />
        </div>
      </SettingsGroupRow>
    </SettingsSection>
  );
}
